import { useEffect } from 'react';
import { debounce } from 'lodash';
import { getOSInfo } from '@/utils/utilsPoint';

const handleResize = debounce(() => {
  const htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
  const htmlDom = document.getElementsByTagName('html')[0];
  const deviceType = new URLSearchParams(window.location.search).get('deviceType');

  if (deviceType === 'desktop') {
    htmlDom.style.fontSize = '100px';
  } else if (getOSInfo().isPc) {
    htmlDom.style.fontSize = `${(100 / 1920) * htmlWidth}px`;
  } else {
    htmlDom.style.fontSize = `${(100 / 375) * htmlWidth}px`;
  }
});

export default function useResponsive() {
  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
}
